import { defineRouter } from '#q-app/wrappers';
import { createMemoryHistory, createRouter, createWebHistory } from 'vue-router';
import routes from './routes';
import * as storageService from '../services/storage';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default defineRouter(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER ? createMemoryHistory : createWebHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });

  Router.beforeEach((to, from, next) => {
    const isAuthenticated = storageService.isLoggedIn();

    if (to.meta.requiredAuth && !isAuthenticated) {
      storageService.setRedirectAfterAuth(to.fullPath);
      next({ name: 'account-login' });
    } else if (
      isAuthenticated &&
      ['account-login', 'account-register'].includes(to.name as string)
    ) {
      next({ name: 'home' });
    } else {
      next();
    }
  });

  return Router;
});
